<template>
  <div>
    <div class="air-approve-settings">
      <div>
        <el-button no="onSave" type="primary" @click="onSave">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onRefresh" type="primary" @click="onRefresh">{{ $t('Pricing.Refresh') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
    </div>
    <air-markup ref="airMarkUp" />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import AirMarkup from '@/views/cargo/v0/Price/PriceAir/components/airMarkup'
import { saveOrUpdateConfig } from '@/api/user'

export default {
  name: 'AirApproveSettings',
  components: { AirMarkup },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    configUtil: {
      type: Object,
      default: () => {
      }
    },
    isHQManager: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      markupLocked: false,
      cfg: {}
    }
  },
  methods: {
    init() {
      this.onSettingsLoaded()
    },
    onSettingsLoaded() {
      let cfg = this.configUtil.markupCfg
      if (cfg === null) {
        if (!this.configUtil.markupCfgDef) {
          this.$message.warning(this.$t('Pricing.NoSetting'))
          return
        }
        cfg = {}
        this.configUtil.markupCfg = cfg
        if (this.isHQManager) {
          cfg.officeId = 1
        } else {
          cfg.officeId = this.$store.getters.currentOfficeId
        }
        cfg.isOverrideable = false
        cfg.configId = this.configUtil.markupCfgDef.configId
      }
      this.cfg = cfg
      this.decodeSetting()
    },
    decodeSetting() {
      const source = this.configUtil.markupCfgValue
      this.$nextTick(() => {
        this.$refs['airMarkUp'].readConfig(!source ? {} : source)
      })
    },
    onSave() {
      if (this.$refs['airMarkUp'].isValid()) {
        this.cfg['value'] = JSON.stringify(this.$refs['airMarkUp'].getMarkups()).replace(/\\/g, '')
        this.fullscreenLoading = getLoading()
        saveOrUpdateConfig(this.cfg).then((res) => {
          this.fullscreenLoading.close()
          this.$message.success(this.$t('Pricing.SavedSucceed'))
          this.configUtil.markupCfg = res.data
          this.configUtil.decodeMarkupSetting()
          this.onCancel()
        }).catch(e => {
          this.fullscreenLoading.close()
        })
      }
    },
    onCancel() {
      this.$emit('close')
    },
    onRefresh() {
      this.decodeSetting()
    }
  }
}
</script>

<style scoped>
.air-approve-settings{
  margin-top: 15px;
}
</style>
